
shadow.loader.init("");
try { kyber.core.init(); } catch (e) { console.error("An error occurred when calling (kyber.core/init)"); throw(e); }